import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const startDateBeforeEndDateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const startDate = control.get('startDate')?.value;
  const endDate = control.get('endDate')?.value;
  return startDate <= endDate ? null : { startDateBeforeEndDate: true };
};
